import type { Agency, AgencyCategory } from '@saaga/shared/interfaces/agencies.interface'

export const agencyCategoryLabelMap: Record<AgencyCategory, string> = {
  marketing: 'Marketing',
  development: 'Development',
  analytics: 'Analytics',
  support: 'Support',
  sales: 'Sales',
  content: 'Content',
  automation: 'Automation',
  research: 'Research',
}

export const allCategoryList: AgencyCategory[] = [
  'marketing',
  'development',
  'analytics',
  'support',
  'sales',
  'content',
  'automation',
  'research',
]

export const mockMarketplaceAgencyList: Agency[] = [
  {
    id: 'agency-1',
    userId: 'user-1',
    name: 'SEO Content Studio',
    slug: 'seo-content-studio',
    description:
      'Comprehensive SEO content creation agency with keyword research, content briefs, and article generation capabilities. Includes competitor analysis, SERP tracking, and content optimization suggestions.',
    logoUrl: null,
    rating: 4.8,
    reviewCount: 256,
    usageCount: 15420,
    priceRange: 2,
    categoryList: ['content', 'marketing'],
    organization: {
      id: 'org-1',
      name: 'ContentPro Inc.',
      logoUrl: null,
    },
    visibility: 'public',
    rejectionReason: null,
    createdAt: '2024-06-15T10:00:00Z',
    updatedAt: '2025-01-10T14:30:00Z',
  },
  {
    id: 'agency-2',
    userId: 'user-2',
    name: 'Data Analytics Suite',
    slug: 'data-analytics-suite',
    description: 'Advanced data analysis and visualization for business intelligence.',
    logoUrl: null,
    rating: 4.5,
    reviewCount: 189,
    usageCount: 8750,
    priceRange: 3,
    categoryList: ['analytics', 'research'],
    organization: {
      id: 'org-2',
      name: 'DataViz Labs',
      logoUrl: null,
    },
    visibility: 'public',
    rejectionReason: null,
    createdAt: '2024-08-20T08:00:00Z',
    updatedAt: '2025-01-08T09:15:00Z',
  },
  {
    id: 'agency-3',
    userId: 'user-3',
    name: 'Social Media Manager',
    slug: 'social-media-manager',
    description:
      'Automate your social media presence with AI-powered content scheduling, engagement analysis, hashtag optimization, audience insights, and cross-platform posting. Perfect for brands looking to scale their social presence without hiring a full team.',
    logoUrl: null,
    rating: 4.2,
    reviewCount: 342,
    usageCount: 22100,
    priceRange: 1,
    categoryList: ['marketing', 'automation', 'content'],
    organization: {
      id: 'org-3',
      name: 'SocialBoost',
      logoUrl: null,
    },
    visibility: 'public',
    rejectionReason: null,
    createdAt: '2024-04-10T12:00:00Z',
    updatedAt: '2025-01-12T16:45:00Z',
  },
  {
    id: 'agency-4',
    userId: 'user-4',
    name: 'Email Campaign Pro',
    slug: 'email-campaign-pro',
    description: 'AI-driven email marketing with personalization and A/B testing.',
    logoUrl: null,
    rating: 4.6,
    reviewCount: 128,
    usageCount: 6890,
    priceRange: 2,
    categoryList: ['marketing', 'sales'],
    organization: {
      id: 'org-4',
      name: 'MailWizard',
      logoUrl: null,
    },
    visibility: 'public',
    rejectionReason: null,
    createdAt: '2024-09-05T14:00:00Z',
    updatedAt: '2025-01-11T11:20:00Z',
  },
  {
    id: 'agency-5',
    userId: 'user-5',
    name: 'Code Review Assistant',
    slug: 'code-review-assistant',
    description:
      'Automated code review and quality analysis for development teams. Supports JavaScript, TypeScript, Python, Go, Rust, and Java. Integrates with GitHub, GitLab, and Bitbucket for seamless PR reviews.',
    logoUrl: null,
    rating: 4.9,
    reviewCount: 89,
    usageCount: 4520,
    priceRange: 2,
    categoryList: ['development', 'automation'],
    organization: {
      id: 'org-5',
      name: 'DevTools Co.',
      logoUrl: null,
    },
    visibility: 'public',
    rejectionReason: null,
    createdAt: '2024-11-01T09:00:00Z',
    updatedAt: '2025-01-14T08:00:00Z',
  },
  {
    id: 'agency-6',
    userId: 'user-6',
    name: 'Customer Support Hub',
    slug: 'customer-support-hub',
    description: 'AI-powered customer support with ticket routing and sentiment analysis.',
    logoUrl: null,
    rating: 4.3,
    reviewCount: 215,
    usageCount: 31500,
    priceRange: 3,
    categoryList: ['support', 'automation'],
    organization: {
      id: 'org-6',
      name: 'SupportAI',
      logoUrl: null,
    },
    visibility: 'public',
    rejectionReason: null,
    createdAt: '2024-03-22T11:00:00Z',
    updatedAt: '2025-01-13T13:30:00Z',
  },
  {
    id: 'agency-7',
    userId: 'user-7',
    name: 'Market Research Agent',
    slug: 'market-research-agent',
    description:
      'Comprehensive market research automation that gathers competitive intelligence, analyzes market trends, identifies opportunities, and generates detailed reports with actionable insights for strategic decision-making.',
    logoUrl: null,
    rating: 0,
    reviewCount: 0,
    usageCount: 23,
    priceRange: 2,
    categoryList: ['research', 'analytics'],
    organization: {
      id: 'org-7',
      name: 'InsightFlow',
      logoUrl: null,
    },
    visibility: 'public',
    rejectionReason: null,
    createdAt: '2025-01-10T09:00:00Z',
    updatedAt: '2025-01-15T14:00:00Z',
  },
]

export const mockMyAgencyList: Agency[] = [
  {
    id: 'my-agency-1',
    userId: 'current-user',
    name: 'Internal Research Bot',
    slug: 'internal-research-bot',
    description: 'Custom research assistant for internal documentation queries.',
    logoUrl: null,
    rating: 0,
    reviewCount: 0,
    usageCount: 145,
    priceRange: 1,
    categoryList: ['research'],
    organization: {
      id: 'my-org',
      name: 'My Organization',
      logoUrl: null,
    },
    visibility: 'private',
    rejectionReason: null,
    createdAt: '2025-01-05T10:00:00Z',
    updatedAt: '2025-01-15T09:00:00Z',
  },
  {
    id: 'my-agency-2',
    userId: 'current-user',
    name: 'Sales Outreach Helper',
    slug: 'sales-outreach-helper',
    description:
      'Personalized sales email generator trained on our brand voice and product catalog. Includes lead scoring, follow-up sequences, and CRM integration.',
    logoUrl: null,
    rating: 0,
    reviewCount: 0,
    usageCount: 89,
    priceRange: 1,
    categoryList: ['sales', 'automation'],
    organization: {
      id: 'my-org',
      name: 'My Organization',
      logoUrl: null,
    },
    visibility: 'draft',
    rejectionReason: null,
    createdAt: '2025-01-10T14:00:00Z',
    updatedAt: '2025-01-14T16:30:00Z',
  },
]

export const mockEmptyAgencyList: Agency[] = []
